<template>
	<div class="work-order">
		<filter-panel :data="groups" @change="change" @search="filterChange"></filter-panel>

		<!-- 新增按钮 -->
		<el-row type="flex" class="row-bg" justify="end">
			<el-button @click="add" type="primary">新增</el-button>
		</el-row>
		<!-- 表单 -->
		<data-list
			:data="data"
			:columns="column"
			:loading="loading"
			:page="page"
			:table-style="{ name: 'mixture' }"
			:page-size="page.pageSize"
			@page-size-changed="pageSizeChanged"
			@page-changed="pageChanged"
			@sort-change="sortChange"
		></data-list>
		<!-- 对话框 -->
		<dialog-form
			:dialogVisible.sync="dialogVisible"
			:formData="formData"
			:attributes="attributes"
			@close:dialogVisible="val => (dialogVisible = val)"
			@confirm="submit"
		></dialog-form>
	</div>
</template>

<script>
import filterPanel from '@/components/iglobalwin/filterPanelNew/filterPanel.vue';
import api from '@/backend/apiConfig/apiConfig';
import workOrder from '@/backend/services/workOrder/workOrder.js';
import simpleFormPageCreate from '@/components/iglobalwin/formCombination/formService.js';
import listPageCreate from '@/mixins/listPageCreate';
import customer from '@/mixins/customer';
import {
	handleType,
	workOrderType,
	webProblemType,
	socialmediaProblemType,
	videoProblemType,
	SaaSProblemType,
	googleProblemType,
} from '@/common/dictionary';
import userSearch from '@/components/tools/userSearch';
import { validRequired } from '@/common/elementValid.js';
import dialogForm from '@/components/dialogForm/dialogForm';
import beforeRouteEnter from '@/mixins/beforeRouteEnter.js';
const list = listPageCreate({
	searchConfig: {
		api: api.workorder.workorderpage,
		method: 'POST',
	},
	getQuery(obj) {
		return _.assign(obj, { listType: 0 });
	},
});

export default {
	name: 'workOrderSubmitted',
	components: { filterPanel, dialogForm },
	mixins: [list, customer, beforeRouteEnter],
	data() {
		let that = this;
		const obj = {
			custName: '',
			serviceCode: '',
			serviceId: '',
			customerId: '',
			workOrderType: '',
			workOrderId: '',
			workType: '',
			domainName: '',
			handleId: '',
			notes: '',
			customerName: '',
			handleName: '',
			workOrderCode: '',
			ossName: [],
		};
		const column = [
			{
				label: '工单编号',
				type: 'custInfo',
				main: 'workOrderCode',
				event(row) {
					that.$router.push({
						name: 'submitWorkOrderDetail',
						query: {
							id: row.workOrderId,
						},
					});
				},
			},
			{
				label: '关联客户',
				type: 'custInfo',
				text: [
					{
						bind: 'customerName',
					},
				],
				minWidth: 100,
			},
			{
				label: '工单类型',
				bind: 'workOrderTypeStr',
			},
			{
				label: '问题类型',
				bind: 'problemTypeStr',
			},
			{
				label: '提交人',
				bind: 'createrName',
			},
			{
				label: '当前处理人',
				bind: 'handleName',
			},
			{
				label: '提交时间',
				type: 'custInfo',
				getClass(row) {
					if (row.isRead === 1) {
						return 'danger';
					}
				},
				text: [
					{
						bind: 'createTimeStr',
						disabled: true,
					},
				],
				sort: 'createTimeStr',
				options: [
					{
						label: '由低到高',
						value: 'asc',
					},
					{
						label: '由高到低',
						value: 'desc',
					},
				],
			},
			{
				label: '完成时间',
				type: 'custInfo',
				text: [
					{
						bind: 'handleTime',
						custValue: row => {
							if (row.handleType === 2) return row.handleTime;
							return '';
						},
					},
				],
			},
			{
				label: '当前处理人',
				bind: 'handleName',
			},
			{
				label: '当前处理时间',
				bind: 'intervalTime',
				getClass(row) {
					if (row.isRead === 1) {
						return 'danger';
					}
				},
			},
			{
				label: '当前状态',
				bind: 'handleTypeStr',
				getClass(row) {
					if (row.handleType === 0) {
						return 'warning';
					}
					if (row.handleType === 1) {
						return 'danger';
					}
					if (row.handleType === 2) {
						return 'normalText';
					}
					if (row.handleType === 3) {
						return 'deathText';
					}
					if (row.handleType === 4) {
						return 'deathText';
					}
				},
			},
			{
				label: '备注',
				type: 'custInfo',
				text: [
					{
						bind: 'remarks',
					},
				],
			},
		];
		return {
			column: column,
			dialogVisible: false,
			obj: obj,
			customerName: '',
			customerId: '',
			// imageFileName: [],
			remarks: '',
			formData: {},
			defaultKey: null,
			workOrderType: '',
			serviceId: '',
			ossName: [],
			attributes: {
				width: '30%',
				clickModal: false,
				labelWidth: '120px',
			},
			groups: {
				others: [
					{
						tagName: 'sky-input',
						placeholder: '工单编号',
						label: '工单编号',
						prop: 'workOrderCode',
						value: '',
					},
					{
						label: '提交时间段',
						startPlaceholder: '提交开始日期',
						endPlaceholder: '提交结束日期',
						prop: ['beginTimeStr', 'endTimeStr'],
						tagName: 'sky-date-picker',
						type: 'daterange',
						value: [],
					},
					{
						label: '完成时间段',
						startPlaceholder: '完成开始日期',
						endPlaceholder: '完成结束日期',
						prop: ['handleStartTimeStr', 'handleEndTimeStr'],
						tagName: 'sky-date-picker',
						type: 'daterange',
						value: [],
					},
				],
				multiples: [
					{
						defaultText: '工单类型',
						placeholder: '工单类型',
						label: '工单类型名称',
						prop: 'workOrderType',
						options: workOrderType,
						value: '',
					},
					{
						defaultText: '任务状态',
						placeholder: '任务状态',
						label: '任务状态',
						options: handleType,
						prop: 'handleType',
						multiple: true,
						value: [],
					},
				],
			},
		};
	},
	watch: {
		'formData.customerId.value'(val) {
			if (val) {
				this.customerId = val;
				this.setObj(this.customerId);
				this.getSelectService();
			}
		},
		'formData.serviceId.value'(val) {
			if (val) {
				this.seviceId = val;
				this.getDomain();
				// this.getHandle()
			}
		},
	},
	methods: {
		add() {
			this.setObj();
			this.dialogVisible = true;
		},

		// 获取关联订单
		async getSelectService() {
			let val = this.customerId;
			let res = await workOrder.selectservice({ customerId: val });
			this.formData.serviceId.options = res.data;
		},
		// 根据服务单信息获取域名
		async getDomain() {
			let res3 = await workOrder.domainbyservice({
				customerId: this.customerId,
				serviceId: this.seviceId,
			});
			this.formData.domainName.value = res3.data == false ? '' : res3.data[0].domianName;
		},

		setObj(id) {
			let that = this;
			this.formData = {
				customerId: {
					formType: 'customer-search',
					value: id || '',
					placeholder: '',
					label: '客户名称',
					defaultKey: this.defaultKey,
					options: [],
					controlButton: false,
					rules: [validRequired('此项必填', 'change')],
				},
				serviceId: {
					label: '关联订单',
					formType: 'sky-select',
					props: {
						label: 'orderCode',
						value: 'serviceId',
					},
					value: this.obj.serviceId,
					options: [],
					rules: [validRequired('此项必填', 'change')],
				},
				workType: {
					label: '工单类型',
					placeholder: '工单类型',
					formType: 'sky-select',
					options: workOrderType,
					value: '',
					prop: 'workOrderType',
					rules: [validRequired('此项必填', 'change')],
					change(val) {
						that.formData.problemType.value = '';
						let problemType = [];
						if (val == 0) {
							problemType = webProblemType;
						}
						if (val == 2) {
							problemType = socialmediaProblemType;
						}
						if (val == 3) {
							problemType = videoProblemType;
						}
						if (val == 4) {
							problemType = googleProblemType;
						}
						if (val == 5) {
							problemType = SaaSProblemType;
						}
						that.formData.problemType.options = problemType;
					},
				},
				domainName: {
					label: '域名',
					formType: 'sky-input',
					value: '',
					rules: [validRequired('此项必填', 'blur')],
				},
				problemType: {
					label: '问题类型',
					placeholder: '问题类型',
					formType: 'sky-select',
					options: [],
					value: '',
					prop: 'problemType',
					rules: [validRequired('此项必填', 'change')],
				},
				handleId: {
					label: '受理人',
					formType: userSearch,
					value: this.obj.handleId,
					rules: [validRequired('此项必填', 'change')],
				},
				remarks: {
					label: '备注',
					formType: 'sky-textarea',
					value: this.obj.remarks,
				},
				fileContentList: {
					label: '附件上传',
					formType: 'sky-uploadImg',
					limit: 6,
					value: this.obj.ossName || [],
				},
			};
		},
		formatUrls(list) {
			return list;
		},
		submit(callback) {
			// 禁用按钮
			let requestApi = api.workorder.saveworkorder;
			let type = 'Post';
			simpleFormPageCreate(
				{
					api: requestApi,
					type: type,
					data: this.formData,
				},
				res => {
					let obj = Object.assign({}, res);
					return obj;
				}
			)
				.submit()
				.then(() => {
					this.dialogVisible = false;
					this.$message.success('工单添加成功');
					this.query();
					callback && callback();
				})
				.catch(() => {
					this.$message.error('工单添加失败');
					callback && callback();
				});
		},
		change() {},
	},
	mounted() {
		// this.query();
		this.setObj();
	},
};
</script>

<style lang="scss" scoped>
.warning {
  color: red;
}
</style>
